// utils/quotationHelper.js

import { generatePremium,generatePremiumById } from "../api/PremiumGeneration";
import { BajajTransactionId } from "../../Redux/Health/action"; 
export const fetchQuotationDataHelper = async ({
    postBody,
    provider,
    extraParams = {},
    setLoading,
    setQuote,
    setncbValue,
    selectedCoverage,
    dispatch,
    productname
  }) => {
    setLoading(true);
    try {
      const response = await generatePremium({
        ...postBody,
        providers: [provider],
        ...extraParams,
      });
  console.log(response,"ghhcd")
      let quote = response?.data; 
     
  
      switch (provider) {
        case "care":
         
          if ( quote?.[0]?.productName==="Care Supreme" && productname==="Supreme") {
            setQuote(quote?.[0]);
          }else{
            if (selectedCoverage > 100) {
            
              setQuote(quote?.[0]);
            } else {
            
              setQuote(quote?.[1]);
            }
           
            const newPostBody = {
              ...postBody,
              abacusId: 6120,
              provider: "CARE",
            };
            const result = await generatePremiumById(newPostBody);
            const ncbValue = result?.data?.body?.data?.extraFields[0]?.selectedValue;
            console.log("Fetched NCB Value:", ncbValue);
            if (setncbValue) setncbValue(ncbValue);
          }
          break;
  
          case "reliance":
            if(productname==="Reliance Infinity"){
                setQuote(quote?.[1])
            }else{
                setQuote(quote?.[0]);
            }
            break;
          
        case "hdfc":
          setQuote(quote?.[0]);
          break;
  
        case "bajaj":
          const transactionId = quote?.[0]?.transactionid;
          if (transactionId && dispatch){
            dispatch(BajajTransactionId(transactionId));
          }
          setQuote(quote?.[0]);
          break;
  
        default:
          setQuote(null);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };


export const getBenefitsForProduct = (productDetails, productName) => {
  const benefitsData = productDetails?.find(
    (benefit) => benefit?.product?.toLowerCase() === productName?.toLowerCase()
  );
  return benefitsData?.features;
};

export const findImage = (Images, providerName) => {
  let imageObj = Images?.find((e) => e?.provider === providerName);
  return imageObj?.image;
};

export const formatPremiumValue = (premium) => {
  let premiumValue =
    typeof premium === "string"
      ? parseFloat(premium.replace(/,/g, ""))
      : premium;
  return premiumValue
    ?.toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const processQuoteData = ({
  quote,
  setProductFeatures,
  setImage,
  setPremium,
  productDetails,
  Images,
  dispatch,
  storeQuote,
}) => {
  const features = getBenefitsForProduct(productDetails, quote?.productName);
  const image = findImage(Images, quote?.provider);
  const formattedPremium = formatPremiumValue(quote?.premiumWithGST);

  setProductFeatures(features);
  setImage(image);
  setPremium(formattedPremium);

  if (dispatch && storeQuote) {
    dispatch(storeQuote(quote));
  }
};
